/**
 * Created by zjs on 2017/09/05
 */
import * as types from './mutation-types'

export default {
    /**
     * 初始化全局路由配置
     */
    initGlobalRouterConfig ({commit}, config) {
        commit(types.INIT_GLOBAL_ROUTER_CONFIG, config)
    },
    /**
     * 更新当前路由信息
     */
    updateCurrRoute ({commit}, route) {
        commit(types.UPDATE_CURR_ROUTE, route)
    },
    /**
     * 更新当前页面信息
     */
    updateCurrPage ({commit}, page) {
        commit(types.UPDATE_CURR_PAGE, page)
    }
} 